"use strict";
import Config from '@/config.js';
import {
  Message,
  Notice
} from 'tanikawa-iview';
import Cookies from 'js-cookie';
import { Decimal } from 'decimal.js';

let utils = {

};

/**
 * 处理状态码
 */
utils.codeStatus = (codeList, data) => {

  let status = false;
  if (!data && !codeList) return;
  if (data == '') {
    status = true;
  }
  if (codeList.indexOf(data, 0) >= 0) {
    status = true;
  }
  return status;
}

//post 方式下载文件
utils.downloadPost = (url, data, token) => {
  const form = document.createElement('form');
  form.action = `${Config.apiUrl}/${url}`;
  form.setAttribute = `${token}`;
  form.method = 'get';
  form.style.display = 'none';
  Object.keys(data).forEach(key => {
    if (Array.isArray(data[key])) {
      for (var i = 0; i < data[key].length; i++) {
        const input = document.createElement('input');
        input.name = `${key}[]`;
        input.value = data[key][i];
        form.appendChild(input);
      }
    } else {
      const input = document.createElement('input');
      input.name = key;
      input.value = data[key];
      form.appendChild(input);
    }

  });
  const button = document.createElement('input');
  button.type = 'submit';
  form.appendChild(button);
  document.body.appendChild(form);
  form.submit();
  document.body.removeChild(form);
}
utils.checkImg = function (filename) {
  const imgSuff = ['.jpeg', '.gif', '.jpg', '.png'];
  for (var i = imgSuff.length - 1; i >= 0; i--) {
    if (filename.indexOf(imgSuff[i]) != -1) {
      return true;
    }
  }
  return false;
}

utils.notice = (content, action = 'warning', duration = 2) => {
  let config = {};
  config.duration = duration;
  config.content = content;
  switch (action) {
    case 'info':
      return Message.info(config);
    case 'success':
      return Message.success(config);
    case 'error':
      return Message.error(config);
    case 'loading':
      return Message.loading(config);
    default:
      return Message.warning(config);
  }
}

utils.message = (title, action = 'warning', duration = 2) => {
  let config = {};
  config.duration = duration;
  config.title = title;
  switch (action) {
    case 'open':
      return Notice.open(config);
    case 'info':
      return Notice.info(config);
    case 'success':
      return Notice.success(config);
    case 'error':
      return Notice.error(config);
    default:
      return Notice.warning(config);
  }
}
/**
 * 获取日期时间戳
 */
utils.timeDiff = (stringTime, type) => {
  if (type == 'start') {
    var timestamp2 = Date.parse(new Date(stringTime + ' 0:0:0')) / 1000;
  } else if (type == 'end') {
    var timestamp2 = Date.parse(new Date(stringTime + ' 0:0:0')) / 1000 + 24 * 60 * 60 - 1;
  }
  return timestamp2
}

/**
 * 获取日期时间时间戳
 */
utils.deteDiff = stringTime => {
  var timestamp2 = Date.parse(new Date(stringTime));
  timestamp2 = timestamp2 / 1000;
  return timestamp2
}

/**
 * 时间戳转成时间
 *
 * @param timestamp  时间戳
 *
 * @returns 格式化的时间
 */
utils.timestampToTime = timestamp => {
  var date = new Date(timestamp * 1000); //时间戳为10位需*1000，时间戳为13位的话不需乘1000
  var Y = date.getFullYear() + '-';
  var M = (date.getMonth() + 1 < 10 ? '0' + (date.getMonth() + 1) : date.getMonth() + 1) + '-';
  var D = date.getDate() + ' ';
  var h = date.getHours() + ':';
  var m = date.getMinutes() + ':';
  var s = date.getSeconds();
  return Y + M + D + h + m + s;
}



/**
 * 过略数据请求前的为空的key
 *
 */
utils.filterData = (formData) => {
  const handleTrim = (value) => {
    if (typeof value == 'string') {
      return value.trim();
    }
  }
  let datas = {}
  for (let key in formData) {
    if (handleTrim(formData[key]) !== '' && formData[key] !== null && formData[key] !== [] && formData[key] !== {}) {
      datas[key] = formData[key]
    }
  }
  return datas
}



/**
 * 验证身份证
 *
 * @param {String} 输入身份证号
 *
 * @return {Boolean} 验证状态 true为正确身份证号
 */
utils.isCard = (card) => {
  var patrn = /(^\d{15}$)|(^\d{18}$)|(^\d{17}(\d|X|x)$)/;
  if (!patrn.exec(card)) {
    return false;
  } else {
    return true;
  }
}

utils.checkLogin = () => {
  if (Cookies.get('park_token')) {
    return true;
  } else {
    return false;
  }
}

utils.saveLogin = (data) => {
  Cookies.set('park_token', data.access_token);
}

utils.loginOut = () => {
  Cookies.set("park_token", "", -1);
  window.location.reload();
}

utils.tokenInvalidTime = (data) => {
  Cookies.set("tokenInvalidTime", data);
}

utils.clearCookies = () => {
  Cookies.set("park_token", "", -1);
  window.localStorage.removeItem('name');
  window.localStorage.removeItem('id');
  window.localStorage.removeItem('auth');
}

utils.plus = (a, b) => {
  return +parseFloat(a + b).toPrecision(12);
}

utils.precision = (val) => {
  return +parseFloat(val).toPrecision(12);
}

utils.downFile = (id) => {
  if (id) {
    window.location.href = `${Config.apiUrl}/plugin-download/${id}?token=${Cookies.get('token')}`;
  }
}


// 千分位分隔符
utils.thousandSeparator = (num) => {
  let number = String(num);
  let arr = [];
  arr = String(number).split('.');
  let integer = arr[0];
  let decimal = '';
  if (number.indexOf(".") > -1) {
    decimal = arr[1];
  }
  var reg = /\d{1,3}(?=(\d{3})+$)/g;
  if (decimal) {
    return (integer + '').replace(reg, '$&,') + "." + decimal;
  } else {
    return (integer + '').replace(reg, '$&,');
  }

}

/**
 * 根据文件名获取文件类型
 * .doc .png ...
 */
utils.getFileType = (filename) => {
  let type = filename.substr(filename.lastIndexOf(".")).toLowerCase();
  return type;
}


utils.nowInDateBetwen = (d1, d2) => {
  //如果时间格式是正确的，那下面这一步转化时间格式就可以不用了
  let dateBegin = new Date(d1);//将-转化为/，使用new Date
  let dateEnd = new Date(d2);//将-转化为/，使用new Date
  let dateNow = new Date();//获取当前时间

  let beginDiff = dateNow.getTime() - dateBegin.getTime();//时间差的毫秒数
  let beginDayDiff = Math.floor(beginDiff / (24 * 3600 * 1000));//计算出相差天数

  let endDiff = dateEnd.getTime() - dateNow.getTime();//时间差的毫秒数
  let endDayDiff = Math.floor(endDiff / (24 * 3600 * 1000));//计算出相差天数
  if (endDayDiff < 0) {//已过期
    return false
  }
  if (beginDayDiff < 0) {//没到开始时间
    return false;
  }
  return true;
}


/**
 * 用于显示的金额
 */
utils.getShowMoney = (money) => {
  if (money || money == 0) {
      return utils.thousandSeparator(utils.getConversionMoney(money));
  } else {
    return ''
  }
}

/**
 * 用于转换的金额
 */
utils.getConversionMoney = (money) => {
  if (money || money == 0) {
      return new Decimal(money).div(new Decimal(100)).toFixed(2)
    // return (money / 100).toFixed(2);
  } else {
    return ''
  }
}


/**
 * 提交使用转换金额
 */
utils.getSubmitMoney = (money) => {
    // return money*100;
    return new Decimal(money).mul(new Decimal(100))
}

/**
 * 加法
 */
utils.additionMoney = (m,n) =>{
    let c = new Decimal(m).add(new Decimal(n)) 
    return c;
}

/**
 * 减法
 */
utils.subtractionMoney = (m,n)=>{
    let d = new Decimal(m).sub(new Decimal(n));
    return d;
}

/**
 * 乘法
 */
utils.multiplicationMoney = (m,n)=>{
    let e = new Decimal(m).mul(new Decimal(n));
    return e;
}

/**
 * 除法
 */
utils.division = (m,n)=>{
    let f = new Decimal(m).div(new Decimal(n))
    return f;
}

utils.DX = (n) => {
  if (Math.abs(n)) {
    var fraction = ['角', '分'];
    var digit = [
      '零', '壹', '贰', '叁', '肆',
      '伍', '陆', '柒', '捌', '玖'
    ];
    var unit = [
      ['元', '万', '亿'],
      ['', '拾', '佰', '仟']
    ];
    var head = n < 0 ? '欠' : '';
    n = Math.abs(n);

    var s = '';
    for (var i = 0; i < fraction.length; i++) {
      s += (digit[Math.floor(n * 10 * Math.pow(10, i)) % 10] + fraction[i]).replace(/零./, '');
    }
    s = s || '整';
    n = Math.floor(n);
    for (var i = 0; i < unit[0].length && n > 0; i++) {
      var p = '';
      for (var j = 0; j < unit[1].length && n > 0; j++) {
        p = digit[n % 10] + unit[1][j] + p;
        n = Math.floor(n / 10);
      }
      s = p.replace(/(零.)*零$/, '').replace(/^$/, '零') + unit[0][i] + s;
    }
    return head + s.replace(/(零.)*零元/, '元')
      .replace(/(零.)+/g, '零')
      .replace(/^整$/, '零元整');
  } else {
    return '零元整'
  }

}


utils.handleAmountLimit = (event, num) => {

  var value = event.target.value;
  let limit = num ? num : 12;
  let arr = [];
  arr = value.split('.');
  let index = value.indexOf('.');
  let index2 = value.indexOf('.', index + 1);
  let promise = new Promise((resolve, reject) => {

    if (value.indexOf(".") == -1) { //没有小数点

      //禁止输入多个0开头 输入00变为0  输入01后变为1
      if ((parseFloat(value) == 0 && value.length > 1) || (parseFloat(value) != 0 && value.charAt(0) == "0")) {
        setTimeout(() => {
          resolve(value.substring(1))
        }, 0)
      }
      if (value.length > limit) {
        setTimeout(() => {
          resolve(value.slice(0, limit))

        }, 0)
      }

    } else { //有小数点
      //取两位小数


      if (value.substring(0, value.indexOf('.')).length <= limit) {
        if (index2 != -1) {
          setTimeout(() => {

            resolve(value.slice(0, index2))
          }, 0)
        }
        let str = '';
        str = value.slice(0, value.indexOf('.')) + value.slice(value.indexOf('.'), value.indexOf('.') + 3);
        setTimeout(() => {
          // resolve(Math.floor(value * 100) / 100)
          // resolve((value * 100 / 100).toFixed(2))
          resolve(str)

        }, 0)
      } else {
        setTimeout(() => {
          resolve(value.slice(0, limit))

        }, 0)
      }

    }
  })
  return promise;
}

utils.handlePasswordLimit = (event) => {
  var value = event.target.value;
  let arr = [];
  arr = value.split('.');
  let index = value.indexOf('.');
  let index2 = value.indexOf('.', index + 1);
  let promise = new Promise((resolve, reject) => {

    if (value.indexOf(".") == -1) { //没有小数点
      //禁止输入多个0开头 输入00变为0  输入01后变为1
      if ((parseFloat(value) == 0 && value.length > 1) || (parseFloat(value) != 0 && value.charAt(0) == "0")) {
        setTimeout(() => {
          resolve(value.substring(1))

        }, 0)
      }
      if (value.length > 6) {

        setTimeout(() => {
          resolve(value.slice(0, 6))

        }, 0)
      }

    } else { //有小数点
      //取两位小数


      if (value.substring(0, value.indexOf('.')).length <= 6) {
        if (index2 != -1) {
          setTimeout(() => {

            resolve(value.slice(0, index2))
          }, 0)
        }
        let str = '';
        str = value.slice(0, value.indexOf('.'));
        setTimeout(() => {
          // resolve(Math.floor(value * 100) / 100)
          // resolve((value * 100 / 100).toFixed(2))
          resolve(str)

        }, 0)
      } else {
        setTimeout(() => {
          resolve(value.slice(0, 6))

        }, 0)
      }

    }
  })
  return promise;
}

/**
 * 图片转为url
 */
utils.fileTransformPreview = (file) => {

    let url = '';
    if (file && file.size && file.type) {
        let binaryData = [];

        binaryData.push(file);

        url = window.URL.createObjectURL(file);
    } else {
        url = file ? file.data.url : '';
    }
    return url;
}
/**
 * 文件预览公共方法
 */
utils.handleOtherFile = (formDate, api) => {
  api.previewPDF(formDate)
    .then(res => {
      if (res.data.url) {
        window.location.href = res.data.url
      } else {
        this.$Message.error({
          content: "预览失败",
          duration: 2
        });
      }
    })
    .catch(err => {
      console.log(err);
    })
}
/**
 * 预览类型判断
 * 图片or文件
 */
utils.checkType = (fileType) => {
  return fileType === "jpg" || fileType === "png" || fileType === "jpeg" || fileType === "bmp" || fileType === "gif"
}
/**
 * 下载文件方法
 */
utils.downloadFile = (data, fileName) => {
  let blob = new Blob([data], { type: data.type })
  let downloadElement = document.createElement('a')
  let href = window.URL.createObjectURL(blob); //创建下载的链接
  downloadElement.href = href;
  downloadElement.download = fileName; //下载后文件名
  document.body.appendChild(downloadElement);
  downloadElement.click(); //点击下载
  document.body.removeChild(downloadElement); //下载完成移除元素
  window.URL.revokeObjectURL(href); //释放blob对象
}



utils.handleBankShow = (BankNo)=>{
  BankNo=BankNo.replace(/\D/g,'').replace(/....(?!$)/g,'$& ')
  return BankNo;
}
   
export default utils;


